import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef, useState, useContext, useRef, useImperativeHandle, useEffect } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { B as BreadcrumbsItemContext } from '../BreadcrumbsItemContext.esm.js';
import { B as BreadcrumbsListContext } from '../BreadcrumbsListContext.esm.js';
import './styles.css';


var styles = {
    "breadcrumbsItem": "BreadcrumbsItem-module_breadcrumbsItem__SXl9k",
    "separator": "BreadcrumbsItem-module_separator__FNfw4"
};

const BreadcrumbsItem = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, ariaCurrent, children }, ref)=>{
    const [isLastItem, setIsLastItem] = useState(false);
    const { itemCount, showLastItemAsCurrentPage } = useContext(BreadcrumbsListContext);
    const itemRef = useRef(null);
    useImperativeHandle(ref, ()=>itemRef.current);
    useEffect(()=>{
        if (itemRef.current?.nextSibling) {
            setIsLastItem(false);
        } else {
            setIsLastItem(true);
        }
    }, [
        itemCount,
        showLastItemAsCurrentPage
    ]);
    const concatenatedClassNames = `${styles.breadcrumbsItem} ${className}`.trim();
    const displayAsCurrentPage = isLastItem && showLastItemAsCurrentPage;
    return /*#__PURE__*/ jsx(BreadcrumbsItemContext.Provider, {
        value: {
            displayAsCurrentPage: isLastItem && showLastItemAsCurrentPage
        },
        children: /*#__PURE__*/ jsxs("li", {
            ref: itemRef,
            id: id,
            className: concatenatedClassNames,
            lang: lang,
            "data-testid": dataTestId,
            "aria-current": displayAsCurrentPage ? 'page' : ariaCurrent,
            children: [
                children,
                !isLastItem && /*#__PURE__*/ jsx("span", {
                    className: styles.separator,
                    "aria-hidden": 'true',
                    children: '/'
                })
            ]
        })
    });
});
BreadcrumbsItem.displayName = 'BreadcrumbsItem';

export { BreadcrumbsItem };
